"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollToMarker;

function scrollToMarker() {
  var marker = document.querySelector('.marker');

  if (!marker) {
    return;
  }

  setTimeout(function () {
    marker.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  }, 1);
}